import React from 'react';

const Solutions = () => {
  return (
    <div className="relative bg-white">
      {/* Background Layer */}

      {/* Content */}
      <div className="relative z-10 px-4 md:px-20 pb-10 md:pt-5 pt-1">
        {/* Heading */}
        <div className=" mt-2  md:mt-2  md:mb-5 mb-2" >
          <h1 className="text-[12px] md:text-[36px] font-bold text-[#FDBD26] md:mb-3">
            Experience Farmnet App
          </h1>
          <h1 className="text-[12px] md:text-[40px] font-bold text-black">
          Contracts
          </h1>
        </div>

        {/* Records Section */}
        <div className="bg-[#2E453D] rounded-md w-full md:h-[630px] h-[175px] relative flex items-center justify-center p-2 md:p-0 mt-4">
          <div className="rounded-xl overflow-hidden relative w-full h-[300px] md:-mt-5   md:h-[700px] flex justify-center items-center cursor-pointer">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744223318/image-1_evxawu.png"
              alt="Mobile"
              className="object-cover w-[20%] h-[50%] md:w-[22%] md:h-[83%] object-center"
            />
            <div className="absolute inset-0 flex justify-center items-center">
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
                alt="Play Icon"
                className="w-[50px] h-[50px] md:w-[110px] md:h-[110px] object-contain"
              />
            </div>
          </div>
          <div className="absolute bottom-[10px] md:bottom-8 left-4 md:left-10 text-white">
            <p className="text-[12px] md:text-[43px] font-bold text-white">Contracts </p>
          
          </div>
          <div className="absolute left-4 md:left-6 top-0 md:top-4 w-[60px] md:w-[200px] h-[50px] md:h-[80px] z-10">
            <img
              src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744195055/image_14_o9yorx.png"
              alt="Logo"
              className="w-full h-full object-contain"
            />
          </div>
              {/* See More Button */}
        <div className="absolute bottom-0 right-0 bg-[#152C24] z-20 rounded-tl-[50px] flex items-center justify-evenly md:px-4 px-1 w-[100px] h-[20px] md:w-[320px] md:h-[82px]">
          <a href="/experiencemain">
            <div className="flex items-center justify-between space-x-3 md:space-x-16 mt-1 md:mt-1 ml-2 md:ml-7">
              <p className="text-[8px] md:text-[23.5px] text-white font-bold">Read more</p>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                alt="Expand"
                className="w-[15px] md:w-[60px] h-[15px] md:h-[50px] object-contain"
              />
            </div>
          </a>
        </div>
        
        </div>
        <p className='md:text-[32px] text-[8px] font-normal md:mt-16 mt-2'>
  <div className="md:mb-10 mb-3" style={{lineHeight:'1.30'}}>
    The contract management solution allows farmers to enter into agreements that guarantee a secure market for their produce.
  </div>
  <div className="md:mb-10 mb-3"  style={{lineHeight:'1.30'}}>
    Contract owners can also ensure a steady supply of raw materials for production.
  </div>
  <div className="md:mb-10 mb-3"  style={{lineHeight:'1.30'}}>
    Farmers can easily deliver their produce as per the contract terms, while using the mobile app to create deliveries and invoices, ensuring prompt payments.
  </div>
  <div className="md:mb-10 mb-3"  style={{lineHeight:'1.30'}}>
    The integrated payment platform within the app ensures seamless and efficient transactions for timely payments.
  </div>
</p>
    <div className='md:h-40 h-5'></div>
      </div>
    </div>
  );
};

export default Solutions;
